import React from 'react';
import { Card, Empty, Timeline } from 'antd';
import moment from 'moment';

export default function OrderShipmentTimeline(props) {
    const { events = [] } = props;

    return (
        <Card title="Lịch sử shipment">
            {events.length === 0 ? (
                <Empty description="Chưa có lịch sử shipment" />
            ) : (
                <Timeline>
                    {events.map((item) => (
                        <Timeline.Item key={item._id || `${item.provider}-${item.created_time}`}>
                            <div><strong>{item.provider || ''}</strong></div>
                            <div>{item.processing_result || ''}</div>
                            <div>{moment(item.created_time).format('HH:mm DD-MM-YYYY')}</div>
                        </Timeline.Item>
                    ))}
                </Timeline>
            )}
        </Card>
    );
}
